import { render } from "./MenuSettings.vue?vue&type=template&id=dd19ccba&scoped=true&ts=true&lang=pug"
import script from "./MenuSettings.vue?vue&type=script&lang=ts"
export * from "./MenuSettings.vue?vue&type=script&lang=ts"

import "./MenuSettings.vue?vue&type=style&index=0&id=dd19ccba&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd19ccba"]])

export default __exports__